import {defineStore} from 'pinia'
import {getBillCycleById} from '@/services/invoiceService'

export const useCostCenterStore = defineStore('cost-center', {
    state: (): ICostCenterState => ({
        billCycle: null,
    }),
    actions: {
        async initBillCycle(billCycleId: number) {
            const response = await getBillCycleById(billCycleId)
            this.billCycle = null
            if (response) 
            {
                this.billCycle = {
                    id: billCycleId,
                    startDay: response.startDay,
                    frequencyUnit: response.frequencyUnit, 
                    frequencyDuration: response.frequencyDuration,
                }
            }
        },
        resetBillCycle() {
            this.billCycle = null;
        },
    },
    getters: {
        billCycleStartDate(state: ICostCenterState) : Date|null {
            if (this.billCycle && this.billCycle.startDay) {
                const curr = new Date()
                const newDate = new Date(curr.getFullYear(), curr.getMonth(), this.billCycle.startDay)
                if (curr < newDate) {
                    // Not again the new period so we display the usage for the previous period.
                    newDate.setMonth(newDate.getMonth() - 1)
                }

                return newDate
            }

            return null;
        },
        billCycleEndDate(state: ICostCenterState) : Date|null {
            if (this.billCycle && this.billCycle.startDay) {
                const startDate = this.billCycleStartDate ? new Date(this.billCycleStartDate) : null
                if (!startDate) {
                    return null 
                }

               let frequencyUnit = this.billCycle.frequencyUnit ?? "month"
               frequencyUnit = frequencyUnit.charAt(0).toUpperCase() + frequencyUnit.slice(1);
               if (["day", "days"].includes(frequencyUnit)) {
                frequencyUnit = "Date"
               }

               const newDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())
               const currUnit = Reflect.apply(newDate[`get${frequencyUnit}` as keyof Date], newDate, [])

               Reflect.apply(newDate[`set${frequencyUnit}` as keyof Date], newDate, [currUnit + 1])

               // The start day is not included so substract one day.
               newDate.setDate(newDate.getDate() - 1)
               
               // Returns the end date.
               return newDate
            }

            return null;
        },
    },
    persist: true,
})

interface ICostCenterState {
    billCycle: {
        id: number,
        startDay: number|null,
        frequencyUnit: string|null, 
        frequencyDuration: number|null,
    }|null
}